import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import IconDragAndDrop from 'components/icons/IconDragAndDrop';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: 30,
    borderRadius: 4,
    border: `1px dashed ${theme.palette.primary.A400}`,
    transition: theme.transitions.create(['border-color'], {
      duration: theme.transitions.duration.short,
    }),
  },
  rootDropActive: {
    borderColor: theme.palette.primary[500],
  },
  iconDragAndDrop: {
    width: 92,
    height: 47,
    marginBottom: 15,
    color: theme.palette.primary.A100,
  },
});

const TemplatesCreateEditFormEmpty = ({ dropActive, classes }) => (
  <div
    className={classNames(classes.root, {
      [classes.rootDropActive]: dropActive,
    })}
  >
    <IconDragAndDrop className={classes.iconDragAndDrop} />
    <Typography
      color="secondary"
      align="center"
    >
      Drag & Drop elements here to create customn questions
    </Typography>
  </div>
);

TemplatesCreateEditFormEmpty.propTypes = {
  dropActive: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootDropActive: PropTypes.string.isRequired,
    iconDragAndDrop: PropTypes.string.isRequired,
  }).isRequired,
};

TemplatesCreateEditFormEmpty.defaultProps = {
  dropActive: false,
};

export default withStyles(styles)(TemplatesCreateEditFormEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/TemplatesCreateEditForm/TemplatesCreateEditFormEmpty.js